import styled from "styled-components";
import { Colors } from "../../styles";

const H4 = styled.h4<{ margin?: boolean }>`
  font-weight: 600;
  font-size: 14px;
  color: ${Colors.black["01"]};
  margin-bottom: ${({ margin = true }) => (!margin ? "0px" : "20px")};
`;

export default H4;
